import { render } from "./CustomerGroup.vue?vue&type=template&id=2b51776a&scoped=true"
import script from "./CustomerGroup.vue?vue&type=script&lang=js"
export * from "./CustomerGroup.vue?vue&type=script&lang=js"

import "./CustomerGroup.vue?vue&type=style&index=0&id=2b51776a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b51776a"]])

export default __exports__